const defaulLoggerOptions = {
    logger: console.warn,
    debug: false,
};
export const getOptionsFactory = (defaultOptions) => (optionsIn) => ({ ...defaulLoggerOptions, ...defaultOptions, ...optionsIn });
//# sourceMappingURL=options-helper.js.map